import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MEDIASTINAL_IMAGE_BASE = "/assets/images/scan_assist/mediastinal";
/** Use until mediastinal images are added */
var FALLBACK_IMAGE = "".concat(MEDIASTINAL_IMAGE_BASE, "/SST.svg");
var MEDIASTINAL_POINT_LABELS = ["SST", "PST"];
/**
 * Mediastinal Protocol step content by point (SST, PST) and phase.
 * Add images under public/assets/images/mediastinal/ when available (e.g. sst_transverse.png).
 */
export function getMediastinalStepContent(t) {
  return {
    0: {
      transverse: {
        label: t("sst", "SST"),
        imageSrc: "".concat(MEDIASTINAL_IMAGE_BASE, "/SST.svg"),
        instructionLine1: t("capture_3_images", "Capture 3 images"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal...")
      },
      longitudinal: {
        label: t("sst", "SST"),
        imageSrc: "".concat(MEDIASTINAL_IMAGE_BASE, "/SST.svg"),
        instructionLine1: t("capture_3_images", "Capture 3 images"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse...")
      }
    },
    1: {
      transverse: {
        label: t("pst", "PST"),
        imageSrc: "".concat(MEDIASTINAL_IMAGE_BASE, "/PST.svg"),
        instructionLine1: t("capture_3_images", "Capture 3 images"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal...")
      },
      longitudinal: {
        label: t("pst", "PST"),
        imageSrc: "".concat(MEDIASTINAL_IMAGE_BASE, "/PST.svg"),
        instructionLine1: t("capture_3_images", "Capture 3 images"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse...")
      }
    }
  };
}
export function getMediastinalPointLabel(pointIndex) {
  var _MEDIASTINAL_POINT_LA;
  return (_MEDIASTINAL_POINT_LA = MEDIASTINAL_POINT_LABELS[pointIndex]) !== null && _MEDIASTINAL_POINT_LA !== void 0 ? _MEDIASTINAL_POINT_LA : String(pointIndex + 1);
}

/** Slide progress per point: 4 (2-2) or 6 (3-3). */
var MEDIASTINAL_SLIDES = {
  0: 6,
  1: 6
};
function slidesConfigFromTotal(total) {
  var half = Math.floor(total / 2);
  return {
    total: total,
    filledByPhase: {
      transverse: 0,
      longitudinal: half,
      submit: total
    }
  };
}
export function getMediastinalSlidesConfig(pointIndex) {
  var _MEDIASTINAL_SLIDES$p;
  return slidesConfigFromTotal((_MEDIASTINAL_SLIDES$p = MEDIASTINAL_SLIDES[pointIndex]) !== null && _MEDIASTINAL_SLIDES$p !== void 0 ? _MEDIASTINAL_SLIDES$p : 4);
}

/**
 * Get step content for a mediastinal point and phase. Uses longitudinal content for "submit" phase.
 */
export function getMediastinalContentForPointPhase(pointIndex, phase, t) {
  var _contentMap$pointInde;
  var contentMap = getMediastinalStepContent(t);
  var pointContent = (_contentMap$pointInde = contentMap[pointIndex]) !== null && _contentMap$pointInde !== void 0 ? _contentMap$pointInde : contentMap[0];
  var effectivePhase = phase === "submit" ? "longitudinal" : phase;
  var content = pointContent[effectivePhase];
  return _objectSpread(_objectSpread({}, content), {}, {
    imageSrc: content.imageSrc || FALLBACK_IMAGE
  });
}